import React from 'react';
import PropTypes from 'prop-types';
import kebabCase from 'lodash/kebabCase';
import cx from 'classnames';
import './TabNav.scss';

const TabNav = props => (
  <nav className="tab-nav">
    <ul>
      {props.items.map((item, index) => (
        <li className={cx('tab-nav-item', { active: props.currentIndex === index })} key={`${kebabCase(item)}-${index}`}>
          <button onClick={props.handleClick(index)}>{item}</button>
        </li>
      ))}
    </ul>
  </nav>
);

TabNav.propTypes = {
  handleClick: PropTypes.func.isRequired,
  currentIndex: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default TabNav;



// WEBPACK FOOTER //
// ./src/client/js/view/components/TabNav/TabNav.js